import {
  FETCH_MAP_DATA_SUCCESS,
  CHANGE_MAP_ZOOM,
  UPDATE_MAP_BOUNDING_BOX,
  UPDATE_MAP_PROPERTY,
  FETCH_SHIPYARDS_DATA_SUCCESS,
  FETCH_SEARCH_DATA_SUCCESS,
  FETCH_VESSEL_TRACKINGS_DATA_SUCCESS,
  FETCH_SHIPYARDS_GEO_DATA_SUCCESS,
  FETCH_ANCHORAGE_GEO_DATA_SUCCESS,
  REMOVE_ROUTE,
  REMOVE_HEATMAP,
  FETCH_VESSELS_IN_ANCHORAGE_SUCCESS,
  FETCH_ALL__ANCHORAGE_GEO_DATA_SUCCESS,
  FETCH_NEW_BUILD_SHIPYARDS_DATA_SUCCESS,
  FLY_TO,
  RESET_VESSEL_POSITION,
  FETCH_SHIPYARDS_WATCHLIST_DATA_SUCCESS,
  RESET_PORT,
  FETCH_ALL_SHIPYARDS_DATA_SUCCESS, RESET_ALL_SHIPYARDS, FETCH_VESSEL_DATA_SUCCESS
} from "../action/map-data.action";
import { RESET_FILTER, UPDATE_FILTER } from "../action/filter.action";
import * as turf from '@turf/turf'
import {
  FETCH_VESSSEL_ROUTE_SUCCESS,
  FETCH_VESSSEL_TRACKING_SUCCESS,
  FETCH_MASTER_DATA_SUCCESS,
  FETCH_VESSEL_VISITS_DATA_SUCCESS,
  FETCH_SHIPYARD_VISITS_DATA_SUCCESS,
  FETCH_VESSELS,
  FETCH_VESSELS_SUCCESS
} from "../action/vessels.action";
import {CHANGE_COMPANY} from "../action/user.action";
import {FETCH_PORT_SERVICES_BY_COMPANY_ID_SUCCESS, RESET_PORT_SERVICES} from "../action/services.action";
import { ADD_EXPECTED_VESSEL_SUCCESS, REMOVE_EXPECTED_VESSEL_BY_ID_SUCCESS } from "../action/expected-vessels.action";

const initialState = {
  currentCompanyId: 0,
  requestSerial: 0,
  searchRequestSerial: 0,
  vesselTrackingsRequestSerial: 0,
  currentMailingListSerial: 0,
  zoom: 10,
  boundingBox:{},
  currentFeature: {},
  currentPropertyMasterData:{},
  currentPropertyVesselVisitsData:[],
  currentPropertyShipyardVisitsData:[],
  currentShipyardIds : [],
  companyAreas : [],
  companyDocks : [],
  anchorageIds:"",
  baseLayer:'mapbox://styles/mapbox/streets-v11',
  mainTrackings:[],
  vesselsInAnchorage : [],
  anchorageRequestSerial: 0,
  shipyardCoordinate : [],
  companyType:'',
  vesselPosition: {
    "type": "FeatureCollection",
    "features": [
    ]
  },
  vesselPolygon: {
    "type": "FeatureCollection",
    "features": [
    ]
  },
  companyAreaPolygon:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  docksPolygon:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  anchorageAreaPolygon:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  allAnchorageAreaPolygon:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  shipyards: {
    "type": "FeatureCollection",
    "features": [
    ]
  },
  shipyardsWatchList: {
    "type": "FeatureCollection",
    "features": [
    ]
  },
  newBuildShipyards: {
    "type": "FeatureCollection",
    "features": [
    ]
  },
  vesselRoute: {
    "type": "FeatureCollection",
    "features": [
    ]
  },
  vesselTracking: {
    "type": "FeatureCollection",
    "features": [
    ]
  },
  shipyardWatchList: {
    "type": "FeatureCollection",
    "features": [
    ]
  },
  vesselWatchList: {
    "type": "FeatureCollection",
    "features": [
    ]
  },
  currentSearchResult:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  underwater:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  waste:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  steel:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  safety:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  electrical:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  environmental:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  workshop:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  flagState:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  classification:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  warehouse:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  docking_consulting:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  engine:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  portService:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  port:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  allShipyards:{
    "type": "FeatureCollection",
    "features": [
    ]
  },
  flyToPosition:[],
  currentMailingList: {},
  reloadMapDataSeq: 0
};

export default function mapDataReducer(state = initialState, action) {
  let surveyFeatures = [];
  let polygonFeatures = [];

  switch (action.type) {
    case RESET_FILTER:
      state.currentFeature = {}
      return{
        ...state,
        searchRequestSerial: (state.searchRequestSerial + 1)
      }
    case FETCH_VESSSEL_TRACKING_SUCCESS:
      let coordinates = action.payload.map(p => [p.x, p.y])
      let tracking = {
        "type": "FeatureCollection",
        "features": [
          {
            "type": "Feature",
            "properties": {
            },
            "geometry": {
              "type": "LineString",
              "coordinates": coordinates
            }
          }
        ]
      }
      Object.assign(state.vesselTracking, tracking);

    return{
      ...state,
      requestSerial: (state.requestSerial + 1)
    }
    case REMOVE_ROUTE:
      let vesselRoute  =  {
        "type": "FeatureCollection",
          "features": [
        ]
      };
      Object.assign(state.vesselRoute, vesselRoute);

      return{
        ...state,
        requestSerial: (state.requestSerial + 1)
      }
    case REMOVE_HEATMAP:
      let vesselTracking  =  {
        "type": "FeatureCollection",
        "features": [
        ]
      };
      Object.assign(state.vesselTracking, vesselTracking);

      return{
        ...state,
        requestSerial: (state.requestSerial + 1)
      }
    case FETCH_VESSSEL_ROUTE_SUCCESS:
      coordinates = action.payload.routePoints.map(p => [p.x, p.y])
      let distance = `${action.payload.distanceNM}Nm(${action.payload.distanceKM}km)`;
      let etaString = `${action.payload.eta}(${action.payload.journeyTimeString})`
      let route = {
        "type": "FeatureCollection",
        "features": [
          {
            "type": "Feature",
            "properties": {
              "destination": action.payload.destination,
              "eta": etaString,
              "distance": distance,
            },
            "geometry": {
              "type": "LineString",
              "coordinates": coordinates
            }
          }
        ]
      }
      Object.assign(state.vesselRoute, route);

      return{
        ...state,
        requestSerial: (state.requestSerial + 1)
      }
    case CHANGE_COMPANY:
      Object.assign(state.shipyards,{
          "type": "FeatureCollection",
            "features": [
         ]
        },)
      return {
        ...state,
        companyType : action.company.type,
        shipyardCoordinate: [],
      }
    case FETCH_SHIPYARDS_DATA_SUCCESS:
      let geojson = action.payload;
      let currentShipyardIds = [];
      if (state.currentSearchResult && state.currentSearchResult.features[0] && state.currentSearchResult.features[0].properties.type==='shipyard'){
        let searchFeature = state.currentSearchResult.features[0]
        geojson.features.push(searchFeature)
      }
      geojson.features.forEach(function (f) {
        if(f.properties.id != null && f.properties.id > 0){
          currentShipyardIds.push(f.properties.id);
        }
      })
      Object.assign(state.shipyards, geojson);

      return {
        ...state,
        companyType : action.payload.features[0].properties.type,
        shipyardCoordinate: action.payload.features[0].geometry.coordinates,
        currentShipyardIds : currentShipyardIds
      }
    case FETCH_MAP_DATA_SUCCESS:
        geojson = action.payload
  
        // if (state.currentSearchResult && state.currentSearchResult.features[0] && state.currentSearchResult.features[0].properties.type==='vessel'){
        //   let searchFeature = state.currentSearchResult.features[0]
        //   geojson.features.push(searchFeature)
        // }
  
        polygonFeatures = [];
        if (state.zoom >= 12) {
          geojson.features.forEach(function (f) {
            if (!f.properties.length || !f.properties.width){
              return;
            }
            let dimA = f.properties.length / 2.0
            let dimB = f.properties.length / 2.0
            let dimC = f.properties.width / 2.0
            let dimD = f.properties.width / 2.0
            if (f.properties.a && f.properties.b && f.properties.c && f.properties.d) {
              dimA = f.properties.a
              dimB = f.properties.b
              dimC = f.properties.c
              dimD = f.properties.d
            }
            let halfWidth = (dimC + dimD)/2.0;
            let p1 = turf.destination(turf.point(f.geometry.coordinates), dimA - halfWidth, 0, { units: 'meters' });
            let p2 = turf.destination(turf.point(f.geometry.coordinates), dimB, 180, { units: 'meters' });
            let p3 = turf.destination(turf.point(f.geometry.coordinates), dimC, 270, { units: 'meters' });
            let p4 = turf.destination(turf.point(f.geometry.coordinates), dimD, 90, { units: 'meters' });
            let p5 = turf.destination(turf.point([p3.geometry.coordinates[0], p1.geometry.coordinates[1]]), halfWidth, 0, { units: 'meters' });
            let p6 = turf.destination(p5.geometry.coordinates, halfWidth, 90, { units: 'meters' });
            let hull = turf.convex(turf.featureCollection([
              turf.point([p3.geometry.coordinates[0], p2.geometry.coordinates[1]]), 
              turf.point([p4.geometry.coordinates[0], p2.geometry.coordinates[1]]), 
              turf.point([p3.geometry.coordinates[0], p1.geometry.coordinates[1]]), 
              turf.point([p4.geometry.coordinates[0], p1.geometry.coordinates[1]]), 
              turf.point(p6.geometry.coordinates)
            ]));
            let heading = 0;
            if (f.properties.heading){
              heading = f.properties.heading;
            } else if (f.properties.cog) {
              heading = f.properties.cog;
            }
            polygonFeatures.push({
              ...turf.transformRotate(hull, heading, {pivot: f.geometry.coordinates}),
              properties: f.properties
            })
          });
        }
        Object.assign(state.vesselPolygon, {
          "type": "FeatureCollection",
          "features": polygonFeatures
        });
  
        surveyFeatures = [];
        geojson.features.forEach(function (f) {
          let days = 360;
          if (f.properties.next_survey) {
            let forecastDate = Date.parse(f.properties.next_survey)
            let dateDiff = (forecastDate - new Date())/(1000 * 3600 * 24)
            if (dateDiff > -31 && dateDiff <= 91) {
              days = 90;
            } else if ( dateDiff > 91 && dateDiff <= 182 ){
              days = 180;
            }
          }
          surveyFeatures.push({
            geometry: f.geometry,
            properties: {
              ...f.properties,
              inSurveyDays: days,
            }
          })
        });
  
        Object.assign(state.vesselPosition, {
          "type": "FeatureCollection",
          "features": surveyFeatures
        });
  
        return {
          ...state,
          requestSerial: (state.requestSerial + 1)
        }
    case FETCH_SHIPYARDS_WATCHLIST_DATA_SUCCESS:
      geojson = action.payload;
      Object.assign(state.shipyardsWatchList, geojson);

      return {
        ...state,
      }
    case FETCH_NEW_BUILD_SHIPYARDS_DATA_SUCCESS:
      currentShipyardIds = state.currentShipyardIds;
      let geojsonNewBuild = action.payload;
      if (state.currentSearchResult && state.currentSearchResult.features[0] && state.currentSearchResult.features[0].properties.type==='shipyard'){
        let searchFeature = state.currentSearchResult.features[0]
        geojsonNewBuild.features.push(searchFeature)
      }
      geojsonNewBuild.features.forEach(function (f) {
        if(f.properties.id != null && f.properties.id > 0){
          currentShipyardIds.push(f.properties.id);
        }
      })
      Object.assign(state.newBuildShipyards, geojsonNewBuild);

      return {
        ...state,
        currentShipyardIds : currentShipyardIds
      }
    case FLY_TO:
      let flyTo = []
      flyTo.push(action.payload.position[0])
      flyTo.push(action.payload.position[1])
      return{
        ...state,
        flyToPosition:flyTo

      }
    case FETCH_VESSELS:
      return{
        currentCompanyId: action.companyId,
        ...state,
        requestSerial: (state.requestSerial + 1)
      }

    case FETCH_VESSEL_DATA_SUCCESS:
      geojson = action.payload
      Object.assign(state.vesselPolygon, {
        "type": "FeatureCollection",
        "features":[]
      });
      if (state.currentSearchResult && state.currentSearchResult.features[0] && state.currentSearchResult.features[0].properties.type==='vessel'){
        let searchFeature = state.currentSearchResult.features[0]
        geojson.features.push(searchFeature)
      }

      let polygonFeatures = [];
      if (state.zoom >= 12) {
        geojson.features.forEach(function (f) {
          if (!f.properties.length || !f.properties.width){
            return;
          }
          let dimA = f.properties.length / 2.0
          let dimB = f.properties.length / 2.0
          let dimC = f.properties.width / 2.0
          let dimD = f.properties.width / 2.0
          if (f.properties.a && f.properties.b && f.properties.c && f.properties.d) {
            dimA = f.properties.a
            dimB = f.properties.b
            dimC = f.properties.c
            dimD = f.properties.d
          }
          let halfWidth = (dimC + dimD)/2.0;
          let p1 = turf.destination(turf.point(f.geometry.coordinates), dimA - halfWidth, 0, { units: 'meters' });
          let p2 = turf.destination(turf.point(f.geometry.coordinates), dimB, 180, { units: 'meters' });
          let p3 = turf.destination(turf.point(f.geometry.coordinates), dimC, 270, { units: 'meters' });
          let p4 = turf.destination(turf.point(f.geometry.coordinates), dimD, 90, { units: 'meters' });
          let p5 = turf.destination(turf.point([p3.geometry.coordinates[0], p1.geometry.coordinates[1]]), halfWidth, 0, { units: 'meters' });
          let p6 = turf.destination(p5.geometry.coordinates, halfWidth, 90, { units: 'meters' });
          let hull = turf.convex(turf.featureCollection([
            turf.point([p3.geometry.coordinates[0], p2.geometry.coordinates[1]]), 
            turf.point([p4.geometry.coordinates[0], p2.geometry.coordinates[1]]), 
            turf.point([p3.geometry.coordinates[0], p1.geometry.coordinates[1]]), 
            turf.point([p4.geometry.coordinates[0], p1.geometry.coordinates[1]]), 
            turf.point(p6.geometry.coordinates)
          ]));
          let heading = 0;
          if (f.properties.heading){
            heading = f.properties.heading;
          } else if (f.properties.cog) {
            heading = f.properties.cog;
          }
          polygonFeatures.push({
            ...turf.transformRotate(hull, heading, {pivot: f.geometry.coordinates}),
            properties: f.properties
          })
        });
      }
      Object.assign(state.vesselPolygon, {
        "type": "FeatureCollection",
        "features": polygonFeatures
      });

      let surveyFeatures = [];
      geojson.features.forEach(function (f) {
        let days = 360;
        if (f.properties.next_survey) {
          let forecastDate = Date.parse(f.properties.next_survey)
          let dateDiff = (forecastDate - new Date())/(1000 * 3600 * 24)
          if (dateDiff > -31 && dateDiff <= 91) {
            days = 90;
          } else if ( dateDiff > 91 && dateDiff <= 182 ){
            days = 180;
          }
        }
        surveyFeatures.push({
          geometry: f.geometry,
          properties: {
            ...f.properties,
            inSurveyDays: days,
          }
        })
      });
      Object.assign(state.vesselPosition, {
        "type": "FeatureCollection",
        "features": surveyFeatures
      });

      return {
        ...state,
        requestSerial: (state.requestSerial + 1)
      }

    case FETCH_VESSELS_SUCCESS:
      geojson = action.payload
      if (state.currentSearchResult && state.currentSearchResult.features[0] && state.currentSearchResult.features[0].properties.type==='vessel'){
        let searchFeature = state.currentSearchResult.features[0]
        geojson.features.push(searchFeature)
      }

      polygonFeatures = [];
      if (state.zoom >= 12) {
        geojson.features.forEach(function (f) {
          if (!f.properties.length || !f.properties.width){
            return;
          }
          let dimA = f.properties.length / 2.0
          let dimB = f.properties.length / 2.0
          let dimC = f.properties.width / 2.0
          let dimD = f.properties.width / 2.0
          if (f.properties.a && f.properties.b && f.properties.c && f.properties.d) {
            dimA = f.properties.a
            dimB = f.properties.b
            dimC = f.properties.c
            dimD = f.properties.d
          }
          let halfWidth = (dimC + dimD)/2.0;
          let p1 = turf.destination(turf.point(f.geometry.coordinates), dimA - halfWidth, 0, { units: 'meters' });
          let p2 = turf.destination(turf.point(f.geometry.coordinates), dimB, 180, { units: 'meters' });
          let p3 = turf.destination(turf.point(f.geometry.coordinates), dimC, 270, { units: 'meters' });
          let p4 = turf.destination(turf.point(f.geometry.coordinates), dimD, 90, { units: 'meters' });
          let p5 = turf.destination(turf.point([p3.geometry.coordinates[0], p1.geometry.coordinates[1]]), halfWidth, 0, { units: 'meters' });
          let p6 = turf.destination(p5.geometry.coordinates, halfWidth, 90, { units: 'meters' });
          let hull = turf.convex(turf.featureCollection([
            turf.point([p3.geometry.coordinates[0], p2.geometry.coordinates[1]]),
            turf.point([p4.geometry.coordinates[0], p2.geometry.coordinates[1]]),
            turf.point([p3.geometry.coordinates[0], p1.geometry.coordinates[1]]),
            turf.point([p4.geometry.coordinates[0], p1.geometry.coordinates[1]]),
            turf.point(p6.geometry.coordinates)
          ]));
          let heading = 0;
          if (f.properties.heading){
            heading = f.properties.heading;
          } else if (f.properties.cog) {
            heading = f.properties.cog;
          }
          polygonFeatures.push({
            ...turf.transformRotate(hull, heading, {pivot: f.geometry.coordinates}),
            properties: f.properties
          })
        });
      }
      Object.assign(state.vesselPolygon, {
        "type": "FeatureCollection",
        "features": polygonFeatures
      });

      surveyFeatures = [];
      geojson.features.forEach(function (f) {
        let days = 360;
        if (f.properties.next_survey) {
          let forecastDate = Date.parse(f.properties.next_survey)
          let dateDiff = (forecastDate - new Date())/(1000 * 3600 * 24)
          if (dateDiff > -31 && dateDiff <= 91) {
            days = 90;
          } else if ( dateDiff > 91 && dateDiff <= 182 ){
            days = 180;
          }
        }
        surveyFeatures.push({
          geometry: f.geometry,
          properties: {
            ...f.properties,
            inSurveyDays: days,
          }
        })
      });
      Object.assign(state.vesselPosition, {
        "type": "FeatureCollection",
        "features": surveyFeatures
      });

      return {
        ...state,
        requestSerial: (state.requestSerial + 1)
      }
    case CHANGE_MAP_ZOOM:
      let currentZoom = action.payload
      return {
        ...state,
        zoom: currentZoom
      }
    case UPDATE_MAP_BOUNDING_BOX:
      return {
        ...state,
        boundingBox: action.payload
      }
    case UPDATE_MAP_PROPERTY:
      Object.assign(state, action.payload)
      return{
        ...state,
        requestSerial: (state.requestSerial + 1)
      }
    case FETCH_SEARCH_DATA_SUCCESS:
      Object.assign(state.currentSearchResult, action.payload)
      Object.assign(state.currentFeature, action.payload.features[0])
      return{
        ...state,
        searchRequestSerial: (state.searchRequestSerial + 1)
      }
    case FETCH_MASTER_DATA_SUCCESS:
      return{
        ...state,
        currentPropertyMasterData: action.payload
      }
    case FETCH_VESSEL_VISITS_DATA_SUCCESS:
      return{
        ...state,
        currentPropertyShipyardVisitsData:[],
        currentPropertyVesselVisitsData: action.payload
      }
    case FETCH_SHIPYARD_VISITS_DATA_SUCCESS:
      return{
        ...state,
        currentPropertyVesselVisitsData:[],
        currentPropertyShipyardVisitsData: action.payload
      }
    case FETCH_VESSEL_TRACKINGS_DATA_SUCCESS:
      let vesselTrackings = []
      action.payload.features.forEach(f => {
        vesselTrackings.push({"coords": f.geometry.coordinates[0]})
      })
      Object.assign(state.mainTrackings, vesselTrackings);
      return {
        ...state,
        vesselTrackingsRequestSerial: (state.vesselTrackingsRequestSerial + 1)
      }

    case FETCH_SHIPYARDS_GEO_DATA_SUCCESS:
      let companyArea = []
      let companyAreas = []
      let docks = []
      let oneDock = []
      action.payload.forEach(f =>{
        f.companyAreasDock.forEach(area => {
          companyArea = []
          area.coordinates.forEach(coor => {
            companyArea.push([coor.x,coor.y])
          })
          companyAreas.push({
            "type": "Feature",
            "properties": {},
            "geometry":{
              "type": "Polygon",
              "coordinates":[companyArea]
            }
          })
        })

        f.dockList.forEach(dock =>{
          oneDock = []
          dock.coordinates.forEach(coor => {
            oneDock.push([coor.x,coor.y])
          })
          docks.push(
            {
              "type": "Feature",
              "properties": {},
              "geometry":{
                "type": "Polygon",
                "coordinates":[oneDock]
              }

            })
        })
      })
      Object.assign(state.companyAreaPolygon, {
        "type": "FeatureCollection",
        "features": companyAreas
      });

      Object.assign(state.docksPolygon, {
        "type": "FeatureCollection",
        "features": docks
      });
      return{
        ...state,
        requestSerial: (state.requestSerial + 1)
      }
    case FETCH_ANCHORAGE_GEO_DATA_SUCCESS:
      let anchorages = []
      Object.assign(state.anchorageAreaPolygon, action.payload);
      action.payload.features.forEach(f =>{
        anchorages += f.id
        anchorages += ","
      })
      return{
        ...state,
        anchorageIds: anchorages,
        requestSerial: (state.requestSerial + 1),
        anchorageRequestSerial: (state.anchorageRequestSerial + 1)
      }
    case FETCH_VESSELS_IN_ANCHORAGE_SUCCESS:
      Object.assign(state.vesselsInAnchorage, action.payload);
      return{
        vesselsInAnchorage: action.payload,
        ...state,
      }
    case FETCH_ALL__ANCHORAGE_GEO_DATA_SUCCESS:
      Object.assign(state.allAnchorageAreaPolygon, action.payload);
      return{
        allAnchorageAreaPolygon: action.payload,
        ...state,
      }
    case FETCH_PORT_SERVICES_BY_COMPANY_ID_SUCCESS:
      let underwaterFeatures = [];
      let wasteFeatures = [];
      let steelFeatures = [];
      let safetyFeatures = [];
      let electricalFeatures = [];
      let environmentalFeatures = [];
      let flagStateFeatures = [];
      let classificationFeatures = [];
      let warehouseFeatures = [];
      let docking_consultingFeatures = [];
      let engineFeatures = [];
      let workshopFeatures= [];
      let portServicesFeatures= [];
      let portIds = [];
      action.payload.features.forEach(f =>{
        if (!portIds.includes(f.properties.port_id)){
          switch (f.properties.type) {
            case "UNTERWATER_SERVICE":
              underwaterFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "WASTE_SERVICE":
              wasteFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "ELECTRICAL_SERVICE":
              electricalFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "STEEL_SERVICE":
              steelFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "SAFTEY_SERVICE":
              safetyFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "ENVIRONMENTAL_SERVICE":
              environmentalFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "FLAG_STATE":
              flagStateFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "CLASSIFICATION":
              classificationFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "WAREHOUSE":
              warehouseFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "DOCKING_CONSULTING":
              docking_consultingFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "ENGINE":
              engineFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "WORKSHOP":
              workshopFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
            case "PORT_SERVICES":
              portServicesFeatures.push(f);
              portIds.push(f.properties.port_id)
              break;
          }
        }
      })
      return{
        ...state,
        requestSerial: (state.requestSerial + 1),
        underwater:{
          "type": "FeatureCollection",
          "features": underwaterFeatures
        },
        waste:{
          "type": "FeatureCollection",
          "features": wasteFeatures
        },
        portService:{
          "type": "FeatureCollection",
          "features": portServicesFeatures
        },
        steel:{
          "type": "FeatureCollection",
          "features": steelFeatures
        },
        safety:{
          "type": "FeatureCollection",
          "features": safetyFeatures
        },
        electrical:{
          "type": "FeatureCollection",
          "features": electricalFeatures
        },
        flagState:{
          "type": "FeatureCollection",
          "features": flagStateFeatures
        },
        classification:{
          "type": "FeatureCollection",
          "features": classificationFeatures
        },
        warehouse:{
          "type": "FeatureCollection",
          "features": warehouseFeatures
        },
        docking_consulting:{
          "type": "FeatureCollection",
          "features": docking_consultingFeatures
        },
        engine:{
          "type": "FeatureCollection",
          "features": engineFeatures
        },
        workshop:{
          "type": "FeatureCollection",
          "features": workshopFeatures
        },
        environmental:{
          "type": "FeatureCollection",
          "features": environmentalFeatures
        },
      }
    case RESET_PORT:
      return{
        ...state,
        requestSerial: (state.requestSerial + 1),
        port:{
          "type": "FeatureCollection",
          "features": []
        },
      }
    case FETCH_ALL_SHIPYARDS_DATA_SUCCESS:
      let allShipyardsFeatures = [];
      action.payload.features.forEach(f =>{
        allShipyardsFeatures.push(f);
      })
      return{
        ...state,
        requestSerial: (state.requestSerial + 1),
        allShipyards:{
          "type": "FeatureCollection",
          "features": allShipyardsFeatures
        },
      }
    case RESET_ALL_SHIPYARDS:
      return{
        ...state,
        requestSerial: (state.requestSerial + 1),
        allShipyards:{
          "type": "FeatureCollection",
          "features": []
        },
        newBuildShipyards:{
          "type": "FeatureCollection",
          "features": []
        },
      }
    case REMOVE_EXPECTED_VESSEL_BY_ID_SUCCESS:
      return{
        ...state,
        reloadMapDataSeq: (state.reloadMapDataSeq + 1)
      }
    case ADD_EXPECTED_VESSEL_SUCCESS:
      return{
        ...state,
        reloadMapDataSeq: (state.reloadMapDataSeq + 1)
      }
    case RESET_VESSEL_POSITION:
      Object.assign(state.vesselPosition, {
        "type": "FeatureCollection",
        "features": []
      });
      return{
        ...state,
      }
    case RESET_PORT_SERVICES:
      return{
        ...state,
        requestSerial: (state.requestSerial + 1),
        underwater:{
          "type": "FeatureCollection",
          "features": []
        },
        waste:{
          "type": "FeatureCollection",
          "features": []
        },
        steel:{
          "type": "FeatureCollection",
          "features": []
        },
        safety:{
          "type": "FeatureCollection",
          "features": []
        },
        electrical:{
          "type": "FeatureCollection",
          "features": []
        },
        flagState:{
          "type": "FeatureCollection",
          "features": []
        },
        classification:{
          "type": "FeatureCollection",
          "features": []
        },
        warehouse:{
          "type": "FeatureCollection",
          "features": []
        },
        docking_consulting:{
          "type": "FeatureCollection",
          "features": []
        },
        engine:{
          "type": "FeatureCollection",
          "features": []
        },
        workshop:{
          "type": "FeatureCollection",
          "features": []
        },
        environmental:{
          "type": "FeatureCollection",
          "features": []
        },
      }
    default:
      return {
        ...state
      };
  }
}